import React, { useEffect } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  Typography,
  Link,
} from '@one-thd/sui-atomic-components';
import { Store, QRCode, BuyAgain } from '@one-thd/sui-icons';
import { SummaryShipment } from '@src/models/returns';
import { TagOnInStoreInstructionsDrawerOpen } from '@src/utils/analytics-tagging';
import { useReturnStore } from '@src/stores/returnStore';
import OrderNumberBarcode from '../return-method/OrderNumberBarcode';
import PostSelectionItems from '../shared/items/PostSelectionItems';

interface ReturnInStoreInstructionsDrawerProps {
  open: boolean;
  onClose: () => void;
  shipment?: SummaryShipment;
}

const ReturnInStoreInstructionsDrawer = ({
  open,
  onClose,
  shipment,
}: ReturnInStoreInstructionsDrawerProps) => {
  const shipmentItems = shipment?.itemsToReturn || [];
  const militaryExchange = useReturnStore((state) => state.militaryExchange);
  const orderDetailsV2 = useReturnStore((state) => state.orderDetailsV2);
  const isPTCOrder = useReturnStore((state) => state.isPTCOrder);

  // Track page load when user opens In-Store Drop-Off Instructions drawer
  useEffect(() => {
    if (open && orderDetailsV2) {
      TagOnInStoreInstructionsDrawerOpen(
        militaryExchange,
        orderDetailsV2,
        isPTCOrder,
      );
    }
  }, [open]);

  return (
    <div className="sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96">
      <Drawer
        open={open}
        onClose={onClose}
        position="right"
        className="drawer-z-index-fix"
      >
        <DrawerHeader
          title="In-Store Drop-Off Instructions"
          onClose={onClose}
        />
        <DrawerBody>
          <div className="sui-mb-4">
            <Typography>Return Items</Typography>
          </div>
          <PostSelectionItems selectedReturnItems={shipmentItems} />
          <div className="sui-mb-4">
            <Typography>Barcode</Typography>
          </div>
          <OrderNumberBarcode />
          <hr className="sui-mb-4" />
          <div className="sui-mb-4 sui-flex sui-gap-3">
            <div className="sui-pt-[6px]">
              <Store />
            </div>
            <Typography>
              Take your return items to any{' '}
              <Link
                href="https://www.homedepot.com/l/storeDirectory"
                target="_blank"
              >
                Home Depot store
              </Link>
              .
            </Typography>
          </div>
          <div className="sui-mb-4 sui-flex sui-gap-3">
            <div className="sui-pt-[6px]">
              <QRCode />
            </div>
            <Typography>
              Show your barcode to an associate at the returns counter.
            </Typography>
          </div>
          <div className="sui-flex sui-gap-3">
            <div className="sui-pt-[6px]">
              <BuyAgain />
            </div>
            <Typography>
              It may take up to 10 business days for your bank to put the funds
              back into your account.
            </Typography>
          </div>
        </DrawerBody>
      </Drawer>
    </div>
  );
};

export default ReturnInStoreInstructionsDrawer;
